import axios from 'axios';

const BASE_URL_BELIEVE = process.env.REACT_APP_URL_BELIEVE
const BASE_URL_AIRNIZER = process.env.REACT_APP_URL_AIRNIZER
const BASE_URL_BELIEVE_NEW = process.env.REACT_APP_URL_BELIEVE_NEW

const axiosPublic = axios.create({
    baseURL: BASE_URL_AIRNIZER
});

const axiosPrivate = axios.create({
    baseURL: BASE_URL_AIRNIZER,
    /*withCredentials: true,*/
    headers: {
        'Content-Type': 'application/json',
    },
});

const axiosPrivateBelieve = axios.create({
    baseURL: BASE_URL_BELIEVE,
    //withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

const axiosPrivateNew = axios.create({
    baseURL: BASE_URL_BELIEVE_NEW,
    /*withCredentials: true,*/
    headers: {
        'Content-Type': 'application/json',
    },
});


axiosPrivate.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + localStorage.getItem("BelieveToken");
    return config;
})

axiosPrivateBelieve.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + localStorage.getItem("BelieveToken");
    return config;
})

axiosPrivateNew.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + localStorage.getItem("BelieveToken");
    return config;
})



export { axiosPublic, axiosPrivate, axiosPrivateBelieve, axiosPrivateNew,BASE_URL_AIRNIZER,BASE_URL_BELIEVE,BASE_URL_BELIEVE_NEW };
